import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import './ResetPassword.css';
import Button from '../../components/Button';
import Logo from '../../components/Logo';
import resetFields from '../../forms/member/reset';
import { extractPhasesOrFail } from '../../helpers/ValueBuilder';
import adminActions from '../../actions/admin';
import formHelpers from '../../helpers/FormHelpers';

const queryString = require('query-string');

class ResetPassword extends Component {
  constructor() {
    super();
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.handleFieldFocus = this.handleFieldFocus.bind(this);

    this.state = { prk: '', fields: resetFields };
  }

  componentDidMount() {
    const { location } = this.props;

    if (location && location.search) {
      this.setState({
        prk: queryString.parse(location.search)['prk'],
        fields: resetFields,
      })
    } else {
      this.setState({
        fields: resetFields
      })
    }
  }

  handleFieldBlur(name) {
    formHelpers.handleFieldBlur(name, 'fields', this);
  }

  handleFieldChange(value, name) {
    formHelpers.handleFieldChange(value, name, 'fields', this);
  }

  handleFieldFocus(name) {
    formHelpers.handleFieldFocus(name, this.state.currentPhase, this);
  }

  handleResetClick() {
    const { fields } = this.state;
    let data = extractPhasesOrFail({ fields });

    if (data) {
      this.props.dispatch(adminActions.reset(data, this.props.router, this.state.prk));
    } else {
      this.setState({
        fields: this.handleFieldBlur(fields)
      })
    }
  }

  render() {
    const { fields } = this.state;
    return (
      <div className="saga-wrap">
        <div className="saga">
          <div className="forgot__form">
            <Logo />
            <h1 className="forgot__title">Password Reset</h1>
            { formHelpers.buildFields(fields, this) }
            <div className="clear"></div>
						<Link to="/" className="signin__forgot simple-link">
              Sign in
						</Link>
            <div className="clear"></div>
            <Button
              text="Reset Password"
              allowHover={true}
              center={true}
              onClick={this.handleResetClick}/>
            <div className="clear"></div>
          </div>
          <div className="clear"></div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    member: state.member
  })
)(ResetPassword);



/** WEBPACK FOOTER **
 ** ./src/containers/ResetPassword/index.js
 **/